__turbopack_context__.v({
  "instructor-stats": "instructor-stats-module-scss-module__zWbX8q__instructor-stats",
  "instructor-stats-image": "instructor-stats-module-scss-module__zWbX8q__instructor-stats-image",
  "instructor-stats-info": "instructor-stats-module-scss-module__zWbX8q__instructor-stats-info",
  "instructor-stats-row": "instructor-stats-module-scss-module__zWbX8q__instructor-stats-row",
});
